import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { Provider } from 'react-redux';

import store from './store';
import { NotificationProvider } from './context/NotificationContext';
import GlobalNotificationBinder from './context/GlobalNotificationBinder';

if (typeof globalThis === 'undefined') {
    window.globalThis = window;
  }

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <NotificationProvider>
                <GlobalNotificationBinder />
                <App />
            </NotificationProvider>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
